import { Injectable, signal } from '@angular/core';

/** Shared context between staff order detail and parent page (breadcrumb). */
@Injectable({ providedIn: 'root' })
export class StaffOrderDetailContextService {
  readonly userId = signal<string | null>(null);

  setUserId(id: string | null | undefined): void {
    const trimmed = id?.trim() ?? '';
    this.userId.set(trimmed || null);
  }

  clear(): void {
    this.userId.set(null);
  }
}
